import React from 'react';

import { Button, buttonClasses, ButtonProps, styled } from '@mui/material';

import { ArrowDownIcon } from '../../../assets/icons';

type Props = ButtonProps & {
  hasOpenMenu: boolean;
};

const QuickNavMenuButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ children, hasOpenMenu, ...rest }, ref) => (
    <StyledMenuButton
      ref={ref}
      variant="contained"
      className={hasOpenMenu ? 'quick-nav-button-active' : undefined}
      endIcon={<ArrowDownIcon />}
      {...rest}
    >
      {children}
    </StyledMenuButton>
  ),
);

export default QuickNavMenuButton;

const StyledMenuButton = styled(Button)(({ theme }) => ({
  ...theme.typography.h6,
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  border: 'none',
  outline: '2px solid var(--color-black)',
  outlineOffset: '-2px',
  backgroundColor: 'transparent',
  color: 'var(--color-black)',
  transition: 'background-color 0.2s linear, box-shadow 0.2s',
  textAlign: 'left',
  padding: '2px 12px 3px 22px !important',

  [theme.breakpoints.up('sm')]: {
    padding: '3px 15px 4px 25px !important',
  },

  [theme.breakpoints.up('lg')]: {
    padding: '4px 20px 5px 30px !important',
  },

  [`.${buttonClasses.endIcon}`]: {
    margin: 0,

    svg: {
      width: '36px',
      height: '36px',
      transition: 'transform 0.3s ease',

      [theme.breakpoints.up('sm')]: {
        width: '42px',
        height: '42px',
      },

      [theme.breakpoints.up('md')]: {
        width: '44px',
        height: '44px',
      },

      [theme.breakpoints.up('lg')]: {
        width: '48px',
        height: '48px',
      },
    },
  },

  [`&.${buttonClasses.contained}.${buttonClasses.colorPrimary}:hover, 
  &.${buttonClasses.contained}.${buttonClasses.colorPrimary}:active, 
  &.${buttonClasses.contained}.${buttonClasses.colorPrimary}:focus, 
  &.quick-nav-button-active`]: {
    backgroundColor: 'var(--color-white)',
    color: 'var(--color-light-red)',
    outlineColor: 'var(--color-light-red)',
  },

  '&.quick-nav-button-active': {
    boxShadow: '0 1px var(--color-medium-light-grey)', // hide the gap between button and menu due to rounding issues.

    [`.${buttonClasses.endIcon} svg`]: {
      transform: 'rotate(180deg)',
    },

    [`.`]: {
      transform: 'rotate(180deg)',
    },
  },
}));
